
<template>
    <div>
        <el-form ref="searchForm" :model="searchData" inline>
            <el-form-item label="UID">
                <el-input v-model="searchData.user_id" size="mini"></el-input>
            </el-form-item>
            <el-form-item label="认证类型">
                <el-select v-model="searchData.type" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, index) in typeList"
                        :key="index"
                        :label="opt.label"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核状态">
                <el-select v-model="searchData.status" size="mini" placeholder="请选择" class="policy-box-input">
                    <el-option
                        v-for="(opt, index) in statusList1"
                        :key="index"
                        :label="opt.label"
                        :value="opt.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size="mini" @click="handlerSearch">
                    查找
                </el-button>
            </el-form-item>
        </el-form>
        <el-table :data="data">
            <el-table-column prop="user_id"
                             label="UID" />
            <el-table-column prop="name"
                             label="联系人姓名" />
            <el-table-column prop="type"
                             label="认证类型"
                             :formatter="function (c,i,v) {return getCertificationType(v)}"
            />
            <el-table-column prop="last_apply_time"
                             label="申请时间" 
                             :formatter="function (c,i,v) {return timeFormatter(v)}"
            />
            <el-table-column prop="last_audit_time"
                             label="审核时间"
                             :formatter="function (c,i,v) {return timeFormatter(v)}"
            />
            <el-table-column prop="status"
                             label="审核状态"
                             :formatter="function (c,i,v) {return getStatus(v)}"
            />
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="small" @click="view(scope.row)" type="primary">审核</el-button>
<!--                    <el-button size="small" @click="view(scope.row)" :type="scope.row.status === 1 ? 'primary' : 'info'">{{ getBtnStatus(scope.row.status) }}</el-button>-->
                    <el-button size="small" type="primary" @click="handleShowDialog(scope.row)">设置费率</el-button>
                </template>
            </el-table-column>
        </el-table>
        <page-bar
            :pageSize="50"
            :currentPageCount="data.length"
            @page-changed="loadData"
            :pageSizes="pageSizes"
        ></page-bar>
        <el-dialog title="实名信息"
                   :visible.sync="showDetail"
                   width="70%">
            <el-form ref="form" label-width="150px" >
                <el-form-item label="认证类型">
                    <el-input :value="getCertificationType(userInfo.type)" disabled></el-input>
                </el-form-item>
                <el-form-item label="UID：">
                    <el-input v-model="userInfo.user_id" disabled></el-input>
                </el-form-item>
                <div v-if="userInfo.type === 1">
                    <el-form-item label="申请人姓名：">
                        <el-input v-model="userInfo.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="申请人身份证：">
                        <el-input v-model="userInfo.id_card" disabled></el-input>
                    </el-form-item>
                </div>
                <div v-if="userInfo.type === 2">
                    <el-form-item label="企业名称：">
                        <el-input v-model="userInfo.company_name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="社会统一信用码：">
                        <el-input v-model="userInfo.company_id" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="法人姓名：">
                        <el-input v-model="userInfo.name" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="法人身份证：">
                        <el-input v-model="userInfo.id_card" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="工商执照：">
                        <img :src="`data:image/*;base64,${company_license_url}`" alt="" style="width: 264px; height: 160px;" @click="previewImage(company_license_url)">
                    </el-form-item>
                </div>
                
                <el-form-item label="身份证照片：">
                    <div class="box">
                        <div><span>正面照片</span><img :src="`data:image/*;base64,${front_url}`" alt="" @click="previewImage(front_url)"></div>
                        <div><span>反面照片</span><img :src="`data:image/*;base64,${back_url}`" alt="" @click="previewImage(back_url)"></div>
                    </div>
                </el-form-item>
                <el-form-item label="审核：">
<!--                    <el-select v-model="verify" :disabled="userInfo.status !== 1">
                        <el-option
                            v-for="(item, index) in verifyList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>-->
                    <el-select v-model="verify">
                        <el-option
                            v-for="(item, index) in verifyList"
                            :key="index"
                            :label="item.label"
                            :value="item.value"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="失败原因：" v-if="!verify">
                    <el-select v-model="userInfo.audit_reason">
                        <el-option
                            v-for="(item, index) in selectList"
                            :key="index"
                            :label="item"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="职业证编号：" v-if="userInfo.type === 1">
                    <el-input v-model="addition.person_certificate_id" placeholder="请填写职业证编号"></el-input>
                </el-form-item>
                <el-form-item label="从业机构名称：" v-if="userInfo.type === 1">
                    <el-input v-model="addition.person_organization_name" placeholder="请填写从业机构名称"></el-input>
                </el-form-item>
                <el-form-item label="平台名称：" v-if="userInfo.type === 2">
                    <el-input v-model="addition.company_platform_name" placeholder="请填写平台名称"></el-input>
                </el-form-item>
                <el-form-item label="备注：" v-if="userInfo.type === 2">
                    <el-input type="textarea" v-model="addition.company_remark" placeholder="备注"></el-input>
                </el-form-item>
            </el-form>
            <div class="btn-box">
                <el-button type="info" size="small" @click="verifyCancle">取消</el-button>
                <el-button type="primary" size="small" @click="verifyConfirm">确定</el-button>
            </div>
            
        </el-dialog>
        <el-dialog :visible.sync="imageViewDialogShow" :before-close="handleImageViewDialogClose">
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: center;width: 80%; margin: 0 auto;">
                <img :src="`data:image/*;base64,${imageUrl}`" alt="" style="max-width: 380px;height: auto;">
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogShow" title="设置佣金率和税率" :modal-append-to-body="true" append-to-body destroy-on-close>
            <SettingRate :userId="setRateUserId" @handleCloseSettingRateDialog="handleCloseSettingRateDialog"></SettingRate>
        </el-dialog>
    </div>
</template>
<script>
import request from '@/api/request.js'
import PageBar from "@/modules/ui/PageBar"
import SettingRate from "@/modules/saas/SettingRate.vue"
import dateFormat from '@/util/date.js'
const statusList = { 1: '待审核', 2: '认证成功', 3:'认证失败', 4:'未认证' }
const statusList1 = [{label: '全部', value: 10 }, { label: '待审核', value: 1}, { label: '认证成功', value: 2 }, { label: '认证失败', value: 3 }]
const typeList = [{label: '全部', value: 10 },{ label: '个人用户', value: 1}, { label: '企业用户', value: 2 }]
export default {
    components: { PageBar, SettingRate },
    data(){
        return{
            data: [],
            pageSizes: [10, 20, 50],
            currentRange: [0, 50],
            filter: {
                user_id: '',
                type: [],
                status: [],
            },
            showDetail: false,
            imageViewDialogShow: false,
            imageUrl: '',
            statusList: statusList,
            statusList1: statusList1,
            typeList: typeList,
            userInfo: {},
            selectList: [],
            verify: true,
            verifyList: [{label: '通过', value: true}, {label: '失败', value: false}],
            front_url: '',
            back_url: '',
            company_license_url: '',
            searchData: {
                user_id: '',
                type: '',
                status: ''
            },
            addition: {
                person_certificate_id: '',
                person_organization_name: '',
                company_platform_name: '',
                company_remark: ''
            },
            currentItem: {},
            dialogVisible: false,
            dialogShow: false,
            commission_rate: null,
            tax_rate: null,
            settlement: [],
            tax: [],
            settlementId: null,
            taxId: null
        }
    },
    computed: {
        setRateUserId(){
            return this.currentItem.user_id
        }
    },
    created() {
        this.loadData([0, 50]);
    },
    mounted() {
        this.getFailReason()
    },
    methods: {
        loadData(range){
            this.data = [];
            this.currentRange = range;
            request.saas
                .post("uc/cert/get_user_certificate_list", {
                    range: range,
                    filter: this.filter
                })
                .then(res => {
                    this.data = res.data.list
                })
        },
        view(item){
            this.userInfo = item
            let addition = this.userInfo.addition
            this.addition.person_certificate_id = addition.person_certificate_id ? addition.person_certificate_id : ''
            this.addition.person_organization_name = addition.person_organization_name ? addition.person_organization_name : ''
            this.addition.company_platform_name = addition.company_platform_name ? addition.company_platform_name : ''
            this.addition.company_remark = addition.company_remark ? addition.company_remark : ''
            this.userInfo.verify = true
            this.showDetail = !this.showDetail

            this.front_url = ''
            this.back_url = ''
            this.company_license_url = ''
            this.getIdentityPhoto(1,item.id_card_front_url)
            this.getIdentityPhoto(2,item.id_card_back_url)
            if(item.company_license_url) {
                this.getIdentityPhoto(3,item.company_license_url)
            }
            
            if( this.userInfo.status === 3 ) {
                this.verify = false
            } else {
                this.verify = true
            }
        },
        handleShowDialog(item) {
            //获取佣金率和税率
            //console.log(item)
            this.currentItem = item
            this.$nextTick(() => {
                this.dialogShow = !this.dialogShow
            })
        },
        handleClose(){
            this.dialogVisible = !this.dialogVisible
        },
        previewImage(url){
            this.imageUrl = url
            this.imageViewDialogShow = !this.imageViewDialogShow
        },
        handleImageViewDialogClose(){
            this.imageViewDialogShow = !this.imageViewDialogShow
            this.imageUrl = ''
        },
        timeFormatter(time){
            if(time <= 0) {
                return '--'
            }
            let date = new Date(time*1000);
            return dateFormat("YYYY-mm-dd HH:MM:SS", date)
        },
        getStatus(status) {
            return statusList[status]
        },
        getCertificationType(type) {
            if(type === 1) {
                return '个人用户'
            } else {
                return '企业用户'
            }
        },
        getFailReason(){
            request.saas.post("uc/cert/get_user_certificate_audit_reason_list", {}).then(res => this.selectList = res.data.list)
        },
        getIdentityPhoto(type, filename){
            request.saas.post("common/get_private_object", {
                filename: filename
            }).then(res => {
                if(type === 1) {
                    this.front_url = res.data.content
                } else if(type === 2) {
                    this.back_url = res.data.content
                } else if(type === 3) {
                    this.company_license_url = res.data.content
                }
            })
        },
        verifyCancle(){
            this.verifyInit()
        },
        verifyConfirm(){
            /*if(this.userInfo.status !== 1) {
                this.verifyInit()
                return
            }*/
            let data = {
                user_id: this.userInfo.user_id,
                status: this.verify ? 2 : 3,
                audit_reason: this.userInfo.audit_reason,
                operator: 'unknown',
                addition: this.addition
            } 
            console.log(data)
            request.saas.post("uc/cert/audit_user_certificate", data).then(() => {
                this.$message.success("审核成功")
                this.verifyInit()
                this.loadData(this.currentRange)
            })
            
        },
        verifyInit(){
            this.showDetail = !this.showDetail
            this.back_url = ''
            this.front_url = ''
            this.company_license_url = ''
            this.verify = true
            this.userInfo = {}
        },
        handlerSearch(){
            
            let filter = {};
            filter.user_id = this.searchData.user_id
            filter.type = this.searchData.type === 10 || !this.searchData.type ? [] : [this.searchData.type]
            filter.status = this.searchData.status === 10 || !this.searchData.status ? [] : [this.searchData.status]
            this.filter = filter
            this.loadData(this.currentRange)
        },
        handleCloseSettingRateDialog(){
            this.dialogShow = !this.dialogShow
        }
    }
}
</script>
<style scoped>
.box{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
}
.box div{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.box div span{
    color: #191919;
    font-size: 14px;
    margin: 14px 0;
}
.box div img{
    width: 140px;
    height: 100px;
}
</style>
